import { Controller } from '@hotwired/stimulus';
import { application } from 'src';
import { isPresent } from '@fretadao/f-js-utils';
import { find } from '@fretadao/f-js-dom';

application.register(
  'admin-dashboard-filter-forms',
  class extends Controller {
    static targets = ['variableInput', 'valueInput']

    connect() {
      this.variableSelectAsSelect2()
        .on("select2:select", (event) => {
          this.valueInputTarget.value = `{${event.params.data.id}}`
          this.valueInputTarget.readOnly = true
        })
        .on("select2:clear", (event) => {
          this.valueInputTarget.value = ""
          this.valueInputTarget.readOnly = false
        })
    }

    variableSelectAsSelect2() {
      return $(this.variableInputTarget)
    }

  })
